import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";

import Examples from "../../Docs/Experimental/CollapsibleCard/CollapsibleCardExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="Collapsible Card"
            description="The collapsible prop on Card allows its contents to be hidden with a collapse button"
            apiSources={["azure-devops-ui-experimental/Components/Card/Card.Props.d.ts"]}
            examples={Examples}
            status={{"design":"Planned (Q3)","code":"Planned (Q3)","docs":"Planned (Q3)"}}
        />
    );
}
}
        
export default Page;